<template>
	<div class="funnel-template-entry" :class="{empty}" @click="$emit('click')">
		<template v-if="empty">
			<div class="empty-container">
				<span class="browse-more">
					<span>Browse more</span>
					<inline-svg :src="require('@/assets/img/get-started/browse-more.svg')" />
				</span>
			</div>
		</template>
		<template v-else>
			<div class="image">
				<img :src="template.thumbnail_url" alt="">

				<!--			<div class="badge" v-if="item.badge">-->
				<!--				<div class="icon">-->
				<!--					<inline-svg :src="item.badge"/>-->
				<!--				</div>-->
				<!--			</div>-->
			</div>
			<div class="title">{{ template.name }}</div>
			<div class="layout-row sub-tags">
				<div class="layout-row uses">
					<inline-svg :src="require('@/assets/img/get-started/screen.svg')" />
					{{short(template.uses)+' '}}
					uses
				</div>
				<div class="layout-row ">
					<inline-svg :src="require(`@/assets/img/get-started/heart${template.liked?'-full':''}.svg`)" />
<!--					<inline-svg :src="require('@/assets/img/get-started/heart.svg')" />-->
					{{short(template.likes)+' '}}
					likes
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import shortValue from "@/helpers/shortValue";

export default {
	name: "funnel-template-entry",
	props: {
		template:{
			default: null,
		},
		empty:{
			type: Boolean,
		}
	},
	methods:{
		short(v){
			return shortValue(v, 1)
		}
	}
}
</script>

<style lang="scss" scoped>
.funnel-template-entry {
	background: $light-blue;
	display: flex;
	flex-direction: column;
	margin-right: 20px;
	margin-bottom: 20px;
	border-radius: 16px;
	overflow: hidden;
	//width: 300px;
	cursor: pointer;
	border: 1px solid rgba(207, 214, 225, 0.32);
	height: 340px;
	//flex-grow: 1;
	//flex-shrink: 1;
	//min-width: 300px;
	//max-width: 400px;
	//flex: 1;
	&:hover {
		background: #EEF4FF;
		box-shadow: 0 5px 10px rgba(0, 0, 0, 0.06);
		.browse-more {
			svg {
				right: -35px;
			}
		}
	}
	&.empty {
		border-style: dashed;
	}

	.empty-container {
		height: 100%;
		width: 100%;
		align-items: center;
		display: flex;
	}
	.browse-more {
		color: #636B7C;
		display: flex;
		align-items: center;
		margin: auto;
		font-size: 16px;
		position: relative;
		svg {
			margin-left: 3px;
			position: absolute;
			right: -30px;
			top: -3px;
			transition: 0.2s ease-in-out all;
		}
	}
	.title {
		color: $black;
		font-weight: bold;
		font-size: 18px;
		margin: 10px 20px;
	}
	.sub-tags {
		color: #636B7C;
		margin: 0 20px 15px;
		svg {
			margin-right: 5px;
		}
		.uses {
			margin-right: 20px;
		}
	}
	.image {
		img {
			height: 250px;
			object-fit: cover;
			width: 100%;
			object-position: top;
		}
	}
}
</style>
